module.exports = __webpack_public_path__ + "img/slot_jdb.186a775c.png";